(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hi-announcement-bar"] && !Shopify.designMode) return;
  try {
    
(function(){
  document.querySelectorAll('.hi-ann-bar').forEach(function(bar){
    var track = bar.querySelector('.hi-ann-track');
    var originalSet = bar.querySelector('.hi-ann-set');
    if (!track || !originalSet) return;

    // Clone sets until track is at least 2× the bar width (ensures no gap at any viewport)
    var barWidth = bar.offsetWidth;
    while (track.scrollWidth < barWidth * 2 + originalSet.offsetWidth) {
      var clone = originalSet.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      track.appendChild(clone);
    }

    // Translate by exactly 1 set width (as % of total track width)
    var setWidth = originalSet.offsetWidth;
    var totalWidth = track.scrollWidth;
    var pct = (setWidth / totalWidth * 100).toFixed(6);
    track.style.setProperty('--hi-ann-translate', '-' + pct + '%');

    // Now start the animation
    track.style.animationPlayState = 'running';
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hi-cart-drawer"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  function getDrawer()   { return document.querySelector('[data-hi-cart]'); }
  function getBackdrop() { return document.querySelector('[data-hi-cart-backdrop]'); }

  /* Escape the header stacking context so z-index works correctly */
  (function () {
    var b = getBackdrop(), d = getDrawer();
    if (b) document.body.appendChild(b);
    if (d) document.body.appendChild(d);
  })();

  function open() {
    var d = getDrawer(), b = getBackdrop();
    if (!d) return;
    d.classList.add('hi-cart--open');
    if (b) b.classList.add('hi-cart-backdrop--open');
    document.body.style.overflow = 'hidden';
  }

  function close() {
    var d = getDrawer(), b = getBackdrop();
    if (!d) return;
    d.classList.remove('hi-cart--open');
    if (b) b.classList.remove('hi-cart-backdrop--open');
    document.body.style.overflow = '';
  }

  function isOpen() {
    var d = getDrawer();
    return d && d.classList.contains('hi-cart--open');
  }

  /* Refresh cart via Shopify section rendering — no page reload */
  function refreshCart() {
    var d = getDrawer();
    var wasOpen = d && d.classList.contains('hi-cart--open');
    if (d) d.classList.add('hi-cart--updating');
    fetch('/?sections=hi-cart-drawer')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var temp = document.createElement('div');
        temp.innerHTML = data['hi-cart-drawer'];
        temp.querySelectorAll('script, style').forEach(function (el) { el.remove(); });
        var newBackdrop = temp.querySelector('[data-hi-cart-backdrop]');
        var newDrawer   = temp.querySelector('[data-hi-cart]');
        var curBackdrop = getBackdrop();
        var curDrawer   = getDrawer();
        if (curBackdrop && newBackdrop) curBackdrop.replaceWith(newBackdrop);
        if (curDrawer   && newDrawer)   curDrawer.replaceWith(newDrawer);
        if (wasOpen) {
          /* Drawer was already open — snap to open state, no slide animation */
          if (newDrawer) { newDrawer.style.transition = 'none'; newDrawer.classList.add('hi-cart--open'); }
          if (newBackdrop) { newBackdrop.style.transition = 'none'; newBackdrop.classList.add('hi-cart-backdrop--open'); }
          document.body.style.overflow = 'hidden';
          /* Restore transitions after next paint so close still animates */
          requestAnimationFrame(function () {
            if (newDrawer) newDrawer.style.transition = '';
            if (newBackdrop) newBackdrop.style.transition = '';
          });
        } else {
          /* Drawer was closed — let CSS transition play the slide-in */
          requestAnimationFrame(function () { open(); });
        }
        /* Update header cart badge */
        return fetch('/cart.js');
      })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var badge = document.querySelector('[data-cart-count]');
        if (badge) badge.textContent = cart.item_count;
      });
  }

  /* Expose for PDP and other sections to trigger after add-to-cart */
  window.hiRefreshCart = function() { refreshCart(); };
  window.hiOpenCart = open;

  /* Open on cart icon click */
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-hi-cart-trigger]')) {
      e.preventDefault();
      open();
    }
  });

  /* Close on close buttons */
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-hi-cart-close]')) close();
  });

  /* Close on tap/click outside the drawer */
  document.addEventListener('pointerdown', function (e) {
    if (!isOpen()) return;
    var d = getDrawer();
    var trigger = document.querySelector('[data-hi-cart-trigger]');
    if (d && d.contains(e.target)) return;
    if (trigger && trigger.contains(e.target)) return;
    close();
  });

  /* Qty change */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty-change]');
    if (!btn) return;
    var item = btn.closest('[data-cart-item]');
    if (!item) return;
    var key   = item.dataset.key;
    var qtyEl = item.querySelector('[data-qty-val]');
    var qty   = parseInt(qtyEl.textContent, 10) + (btn.dataset.qtyChange === '+' ? 1 : -1);
    if (qty < 0) qty = 0;
    var d = getDrawer();
    if (d) d.classList.add('hi-cart--updating');
    fetch('/cart/change.js', {
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify({id: key, quantity: qty})
    }).then(refreshCart);
  });

  /* Remove item */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-remove-item]');
    if (!btn) return;
    var d = getDrawer();
    if (d) d.classList.add('hi-cart--updating');
    fetch('/cart/change.js', {
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify({id: btn.dataset.removeItem, quantity: 0})
    }).then(refreshCart);
  });

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hi-collection-product-grid"] && !Shopify.designMode) return;
  try {
    
(function() {
  /* Toolbar sticky positioning — exact logic from the approved design HTML.
     Scroll DOWN past 200px → toolbar at top:0 (header hides, toolbar takes its place).
     Any scroll UP          → toolbar at sticky-nav height (tucks under the header).
     CSS transition on toolbar.style.top gives the same smooth .35s slide as the design.

     NOTE: Dawn wraps each header section in its own .shopify-section-group-header-group div.
     querySelector() returns the FIRST match — the announcement bar (40px, position:static).
     We need the STICKY nav section specifically, so filter for position:sticky. */
  function initToolbarPositioner() {
    var hg = Array.from(document.querySelectorAll('.shopify-section-group-header-group'))
      .find(function(el) { return getComputedStyle(el).position === 'sticky'; });
    var toolbar = document.querySelector('.hi-toolbar-bar');
    if (!toolbar) return;

    toolbar.style.transition = 'top .35s cubic-bezier(.2,.7,.3,1)';

    var headerH = hg ? hg.offsetHeight : 75;
    var lastY = window.scrollY || 0;
    var hidden = false;

    function apply(isHidden) {
      hidden = isHidden;
      toolbar.style.top = (isHidden ? 0 : headerH) + 'px';
      document.documentElement.style.setProperty('--hi-header-h', (isHidden ? 0 : headerH) + 'px');
      document.documentElement.style.setProperty('--hi-toolbar-h', toolbar.offsetHeight + 'px');
    }

    apply(false);

    window.addEventListener('scroll', function() {
      var y = window.scrollY || 0;
      apply(y > lastY && y > 200);
      lastY = y;
    }, { passive: true });

    window.addEventListener('resize', function() {
      headerH = hg ? hg.offsetHeight : 75;
      apply(hidden);
    });
  }
  initToolbarPositioner();

  /* Stub menu-drawer custom element so facets.js renderAdditionalElements()
     doesn't throw when calling .closest('menu-drawer').bindEvents() */
  if (!customElements.get('menu-drawer')) {
    customElements.define('menu-drawer', class extends HTMLElement {
      bindEvents() {}
    });
  }

  /* Event delegation — accordion toggle */
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('[data-hi-filter-toggle]');
    if (!btn) return;
    var group = btn.closest('.hi-filter-group');
    var body = group && group.querySelector('.hi-filter-body');
    var expanded = btn.getAttribute('aria-expanded') !== 'false';
    btn.setAttribute('aria-expanded', expanded ? 'false' : 'true');
    if (body) {
      body.style.maxHeight = expanded ? '0' : '600px';
    }
  });

  /* Mobile filter drawer open */
  document.addEventListener('click', function(e) {
    if (!e.target.closest('[data-hi-drawer-open]')) return;
    var drawer = document.getElementById('hi-filter-drawer');
    var backdrop = document.getElementById('hi-filter-backdrop');
    if (drawer) { drawer.setAttribute('data-open', 'true'); drawer.removeAttribute('aria-hidden'); }
    if (backdrop) backdrop.setAttribute('data-open', 'true');
    document.body.style.overflow = 'hidden';
  });

  /* Mobile filter drawer close */
  document.addEventListener('click', function(e) {
    var isCloseBtn = !!e.target.closest('[data-hi-drawer-close]');
    var isBackdrop = e.target.id === 'hi-filter-backdrop';
    if (!isCloseBtn && !isBackdrop) return;
    var drawer = document.getElementById('hi-filter-drawer');
    var backdrop = document.getElementById('hi-filter-backdrop');
    if (drawer) { drawer.setAttribute('data-open', 'false'); drawer.setAttribute('aria-hidden', 'true'); }
    if (backdrop) backdrop.setAttribute('data-open', 'false');
    document.body.style.overflow = '';
  });

  /* Sort bridge: #SortBy lives inside FacetFiltersForm (DOM) but is form-
     associated with FacetSortForm via form="FacetSortForm". FormData picks it
     up for FacetSortForm (once), not FacetFiltersForm — no duplicate sort_by.
     Change events bubble via DOM so facets.js picks them up via FacetFiltersForm.
     We only need to keep the mobile hidden input in sync. */
  var sortSelect = document.getElementById('SortBy');
  if (sortSelect) {
    sortSelect.addEventListener('change', function() {
      var mobileInputs = document.querySelectorAll('#FacetFiltersFormMobile input[name="sort_by"]');
      mobileInputs.forEach(function(inp) { inp.value = sortSelect.value; });
    });
  }

  /* AJAX Load More — fetches next page and appends cards to the current grid */
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('.hi-loadmore');
    if (!btn || !btn.dataset.url) return;

    var url = btn.dataset.url;
    var originalText = btn.textContent.trim();
    btn.textContent = '...';
    btn.disabled = true;

    fetch(url)
      .then(function(res) { return res.text(); })
      .then(function(html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');

        /* Append new product cards */
        var newCards = doc.querySelectorAll('.hi-prod-grid .hi-card');
        var currentGrid = document.querySelector('.hi-prod-grid');
        if (currentGrid && newCards.length) {
          newCards.forEach(function(card) { currentGrid.appendChild(card); });
        }

        /* Swap pagination section (or remove if last page) */
        var currentPagination = document.querySelector('.hi-pagination');
        var newPagination = doc.querySelector('.hi-pagination');
        if (currentPagination) {
          if (newPagination) {
            var oldFill = currentPagination.querySelector('.hi-pagination-fill');
            var oldWidth = oldFill ? oldFill.style.width : '0%';
            currentPagination.outerHTML = newPagination.outerHTML;
            /* Animate the fill from old width to new width */
            var newFill = document.querySelector('.hi-pagination-fill');
            if (newFill) {
              var targetWidth = newFill.style.width;
              newFill.style.transition = 'none';
              newFill.style.width = oldWidth;
              requestAnimationFrame(function() {
                requestAnimationFrame(function() {
                  newFill.style.transition = '';
                  newFill.style.width = targetWidth;
                });
              });
            }
          } else {
            currentPagination.remove();
          }
        }
      })
      .catch(function() {
        btn.textContent = originalText;
        btn.disabled = false;
      });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hi-contact-faq"] && !Shopify.designMode) return;
  try {
    
(function() {
  document.querySelectorAll('[data-faq-btn]').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var expanded = btn.getAttribute('aria-expanded') === 'true';
      var panelId = btn.getAttribute('aria-controls');
      var panel = document.getElementById(panelId);
      btn.setAttribute('aria-expanded', expanded ? 'false' : 'true');
      if (panel) {
        if (expanded) {
          panel.hidden = true;
        } else {
          panel.hidden = false;
        }
      }
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hi-faq-body"] && !Shopify.designMode) return;
  try {
    
(function() {
  var btns = document.querySelectorAll('[data-faq-btn]');
  btns.forEach(function(btn) {
    btn.addEventListener('click', function() {
      var expanded = btn.getAttribute('aria-expanded') === 'true';
      var panelId = btn.getAttribute('aria-controls');
      var panel = document.getElementById(panelId);
      btn.setAttribute('aria-expanded', expanded ? 'false' : 'true');
      if (panel) panel.hidden = expanded;
    });
  });

  var catBtns = document.querySelectorAll('[data-cat-btn]');
  function setActive(targetId) {
    catBtns.forEach(function(b) {
      b.setAttribute('data-on', b.getAttribute('data-target') === targetId ? 'true' : 'false');
    });
  }
  catBtns.forEach(function(btn) {
    btn.addEventListener('click', function() {
      var targetId = btn.getAttribute('data-target');
      var el = document.getElementById(targetId);
      if (el) {
        var top = el.getBoundingClientRect().top + window.scrollY - 140;
        window.scrollTo({ top: top, behavior: 'smooth' });
      }
      setActive(targetId);
    });
  });

  if ('IntersectionObserver' in window) {
    var groups = document.querySelectorAll('[data-faq-group]');
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) setActive(entry.target.id);
      });
    }, { rootMargin: '-20% 0px -60% 0px' });
    groups.forEach(function(g) { observer.observe(g); });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hi-featured-collection"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-hi-carousel]').forEach(function(sec){
  var track=sec.querySelector('[data-track]');
  var prev=sec.querySelector('[data-prev]');
  var next=sec.querySelector('[data-next]');
  if(!track||!prev||!next)return;
  var card=track.querySelector('.hi-card');

  // Pin arrows to vertical center of card image
  var imgWrap=card&&card.querySelector('.hi-card-img-wrap');
  if(imgWrap){
    var arrowTop=imgWrap.offsetTop+Math.round(imgWrap.offsetHeight/2);
    [prev,next].forEach(function(btn){btn.style.top=arrowTop+'px';});
  }

  // Scroll navigation
  function scrollBy(dir){var w=card?card.offsetWidth+20:280;track.scrollBy({left:dir*w,behavior:'smooth'});}
  prev.addEventListener('click',function(){scrollBy(-1);});
  next.addEventListener('click',function(){scrollBy(1);});
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hi-header"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  var burger   = document.querySelector('[data-hi-burger]');
  var backdrop = document.querySelector('[data-hi-drawer-backdrop]');
  var drawer   = document.querySelector('[data-hi-drawer]');
  var closeBtn = document.querySelector('[data-hi-drawer-close]');

  function openDrawer() {
    if (!drawer) return;
    drawer.setAttribute('data-open', 'true');
    if (backdrop) backdrop.setAttribute('data-open', 'true');
    if (burger) burger.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.removeAttribute('data-open');
    if (backdrop) backdrop.removeAttribute('data-open');
    if (burger) burger.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  }

  if (burger)   burger.addEventListener('click', openDrawer);
  if (backdrop) backdrop.addEventListener('click', closeDrawer);
  if (closeBtn) closeBtn.addEventListener('click', closeDrawer);

  // Close on tap/click anywhere outside the drawer (works on all touch devices)
  document.addEventListener('pointerdown', function(e) {
    if (!drawer || drawer.getAttribute('data-open') !== 'true') return;
    if (drawer.contains(e.target)) return;
    if (burger && burger.contains(e.target)) return;
    closeDrawer();
  });
  if (drawer) {
    drawer.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', closeDrawer);
    });
  }

  /* Desktop submenu toggles */
  const navToggles = document.querySelectorAll('[data-hi-nav-toggle]');
  const closeNavMenus = (except) => {
    navToggles.forEach(toggle => {
      if (toggle === except) return;
      const item = toggle.closest('.hi-navitem');
      if (item) item.setAttribute('data-open', 'false');
      toggle.setAttribute('aria-expanded', 'false');
    });
  }
  navToggles.forEach(toggle => {
    toggle.addEventListener('click', () => {
      const item = toggle.closest('.hi-navitem');
      if (!item) return;
      const isOpen = item.getAttribute('data-open') === 'true';
      closeNavMenus(toggle);
      item.setAttribute('data-open', isOpen ? 'false' : 'true');
      toggle.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
    });
  });
  document.addEventListener('pointerdown', e => {
    if (!e.target.closest('.hi-desktop-nav')) closeNavMenus();
  });
  document.addEventListener('keydown', e => {
    if (e.key !== 'Escape') return;
    const openToggle = document.querySelector('[data-hi-nav-toggle][aria-expanded="true"]');
    closeNavMenus();
    if (openToggle) openToggle.focus();
  });

  /* Accordion */
  document.querySelectorAll('[data-hi-acc]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var isOpen = btn.getAttribute('data-open') === 'true';
      var panel  = btn.nextElementSibling;
      btn.setAttribute('data-open',     isOpen ? 'false' : 'true');
      btn.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
      if (panel) panel.setAttribute('data-open', isOpen ? 'false' : 'true');
    });
  });

  /* Sticky + scroll hide / show
     CSS sticky on .hi-header alone is constrained by its .shopify-section parent
     (same height = 74px), so we promote sticky to the wrapper — same approach as Dawn.
     We then animate `top` (not translateY) to hide/show without leaving a layout gap. */
  var header = document.querySelector('[data-hi-header]');
  if (header) {
    var stickyTarget = header;
    var sect = header.closest('.shopify-section');
    if (sect) {
      sect.style.position = 'sticky';
      sect.style.top = '0';
      sect.style.zIndex = '50';
      sect.style.transition = 'top .35s cubic-bezier(.2,.7,.3,1)';
      stickyTarget = sect;
    }
    var lastY = 0, ticking = false;
    window.addEventListener('scroll', function () {
      if (!ticking) {
        requestAnimationFrame(function () {
          var y = window.scrollY || 0;
          stickyTarget.style.top = (y > lastY && y > 140) ? '-74px' : '0';
          lastY = y;
          ticking = false;
        });
        ticking = true;
      }
    }, { passive: true });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hi-product-main"] && !Shopify.designMode) return;
  try {
    
(function() {
  'use strict';

  var pdpState = {};

  function initPdp(sectionId) {
    var el = document.getElementById('hi-pdp-json-' + sectionId);
    if (!el) return;

    var data;
    try { data = JSON.parse(el.textContent); } catch(e) { return; }

    var idInput = document.getElementById('hi-variant-id-' + sectionId);
    var initialVariantId = idInput ? parseInt(idInput.value, 10) : null;
    var initialVariant = data.variants.find(function(v) { return v.id === initialVariantId; }) || data.variants[0];

    pdpState[sectionId] = {
      data: data,
      selectedOptions: initialVariant ? [initialVariant.option1, initialVariant.option2, initialVariant.option3] : [null, null, null],
      qty: 1
    };

    // Form submit handler
    var form = document.getElementById('hi-pdp-form-' + sectionId);
    if (form) {
      form.addEventListener('submit', function(e) {
        e.preventDefault();
        hiAddToCart(sectionId);
      });
    }

    // Sticky bar observer — show only when buy row is off-screen AND footer is not yet in view
    var buyrow = document.getElementById('hi-buyrow-' + sectionId);
    var stickybar = document.getElementById('hi-stickybar-' + sectionId);
    if (buyrow && stickybar && window.IntersectionObserver) {
      var buyrowVisible = true;
      var footerVisible = false;

      function updateStickyBar() {
        var show = !buyrowVisible && !footerVisible;
        stickybar.classList.toggle('hi-stickybar--show', show);
        stickybar.setAttribute('aria-hidden', show ? 'false' : 'true');
      }

      new IntersectionObserver(function(entries) {
        buyrowVisible = entries[0].isIntersecting;
        updateStickyBar();
      }, { threshold: 0 }).observe(buyrow);

      var footer = document.querySelector('footer, .hi-footer, [class*="hi-foot"]');
      if (footer) {
        new IntersectionObserver(function(entries) {
          footerVisible = entries[0].isIntersecting;
          updateStickyBar();
        }, { threshold: 0 }).observe(footer);
      }
    }
  }

  // Thumbnail carousel
  var hiThumbPos = {};
  var HI_THUMB_H = 112; // 84px wide × 3:4 ratio = 112px tall
  var HI_THUMB_GAP = 12;
  var HI_VISIBLE = 4;

  function hiThumbUpdateBtns(sectionId, pos, total) {
    var btnUp = document.getElementById('hi-tcbtn-up-' + sectionId);
    var btnDown = document.getElementById('hi-tcbtn-down-' + sectionId);
    if (btnUp) btnUp.disabled = pos <= 0;
    if (btnDown) btnDown.disabled = pos >= total - HI_VISIBLE;
  }

  window.hiThumbNav = function(sectionId, dir) {
    if (window.innerWidth <= 640) {
      var viewport = document.querySelector('#hi-tcarousel-' + sectionId + ' .hi-thumbs-viewport');
      if (viewport) viewport.scrollBy({ left: dir * 132, behavior: 'smooth' });
      return;
    }
    var thumbs = document.getElementById('hi-thumbs-' + sectionId);
    if (!thumbs) return;
    var total = thumbs.querySelectorAll('.hi-thumb').length;
    if (total <= HI_VISIBLE) return;
    var pos = (hiThumbPos[sectionId] || 0) + dir;
    pos = Math.min(total - HI_VISIBLE, Math.max(0, pos));
    hiThumbPos[sectionId] = pos;
    thumbs.style.transform = 'translateY(-' + (pos * (HI_THUMB_H + HI_THUMB_GAP)) + 'px)';
    hiThumbUpdateBtns(sectionId, pos, total);
  };

  function hiThumbScrollToActive(sectionId, mediaId) {
    var thumbs = document.getElementById('hi-thumbs-' + sectionId);
    if (!thumbs) return;
    var thumbEls = thumbs.querySelectorAll('.hi-thumb');
    var total = thumbEls.length;
    if (total <= HI_VISIBLE) return;
    var activeIndex = -1;
    thumbEls.forEach(function(t, i) { if (t.dataset.mediaId == mediaId) activeIndex = i; });
    if (activeIndex < 0) return;
    var pos = hiThumbPos[sectionId] || 0;
    if (activeIndex < pos) pos = activeIndex;
    else if (activeIndex >= pos + HI_VISIBLE) pos = activeIndex - HI_VISIBLE + 1;
    if (pos !== (hiThumbPos[sectionId] || 0)) {
      hiThumbPos[sectionId] = pos;
      thumbs.style.transform = 'translateY(-' + (pos * (HI_THUMB_H + HI_THUMB_GAP)) + 'px)';
      hiThumbUpdateBtns(sectionId, pos, total);
    }
  }

  window.hiPdpSelectMedia = function(sectionId, mediaId) {
    document.querySelectorAll('#hi-gallery-' + sectionId + ' .hi-gallery-slide').forEach(function(s) {
      s.classList.toggle('hi-gallery-slide--active', s.dataset.mediaId == mediaId);
    });
    document.querySelectorAll('#hi-gallery-' + sectionId + ' .hi-thumb').forEach(function(t) {
      t.classList.toggle('hi-thumb--active', t.dataset.mediaId == mediaId);
    });
    hiThumbScrollToActive(sectionId, mediaId);
  };

  window.hiPdpSelectOption = function(sectionId, optionIndex, value) {
    var state = pdpState[sectionId];
    if (!state) return;

    state.selectedOptions[optionIndex] = value;

    // Update active classes — toggle only the class that matches the element type
    document.querySelectorAll('[data-section-id="' + sectionId + '"][data-option-index="' + optionIndex + '"]').forEach(function(el) {
      var isActive = el.dataset.value === value;
      if (el.classList.contains('hi-color')) {
        el.classList.toggle('hi-color--active', isActive);
      } else {
        el.classList.toggle('hi-size--active', isActive);
      }
    });

    var variant = findVariant(state);
    if (!variant) return;

    // Update hidden input
    var idInput = document.getElementById('hi-variant-id-' + sectionId);
    if (idInput) idInput.value = variant.id;

    // Update URL with variant ID (matching standard Shopify behavior)
    if (history && history.replaceState) {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      history.replaceState({}, '', url.toString());
    }

    // Update price
    var priceMain = document.querySelector('#hi-price-' + sectionId + ' .hi-price-main');
    if (priceMain) priceMain.textContent = variant.price_formatted;
    var compareEl = document.querySelector('#hi-price-' + sectionId + ' .hi-price-compare');
    if (variant.compare_at_price > variant.price) {
      if (!compareEl) {
        compareEl = document.createElement('span');
        compareEl.className = 'hi-price-compare';
        document.getElementById('hi-price-' + sectionId).appendChild(compareEl);
      }
      compareEl.textContent = variant.compare_at_price_formatted;
      compareEl.style.display = '';
    } else if (compareEl) {
      compareEl.style.display = 'none';
    }

    // Update ATC buttons
    var atcText = variant.available ? window.hiI18n.add_to_cart : window.hiI18n.sold_out;
    ['hi-atc-btn-' + sectionId, 'hi-sticky-atc-' + sectionId].forEach(function(id) {
      var btn = document.getElementById(id);
      if (btn) { btn.disabled = !variant.available; btn.textContent = atcText; }
    });

    // Update variant display in sticky bar
    var variantEl = document.getElementById('hi-sticky-variant-' + sectionId);
    if (variantEl) {
      var isDefault = variant.title === 'Default Title';
      variantEl.textContent = isDefault ? '' : variant.title;
      variantEl.style.display = isDefault ? 'none' : '';
    }

    // Switch gallery to variant media
    if (variant.featured_media_id) {
      hiPdpSelectMedia(sectionId, variant.featured_media_id);
    }

    // Update color name
    if (optionIndex === 0) {
      var colorName = document.getElementById('hi-color-name-' + sectionId);
      if (colorName) colorName.textContent = value;
    }

    // Update size availability based on selected color
    updateSizeAvailability(sectionId, state);
  };

  function findVariant(state) {
    var opts = state.selectedOptions;
    return state.data.variants.find(function(v) {
      return (opts[0] === null || v.option1 === opts[0]) &&
             (opts[1] === null || v.option2 === opts[1]) &&
             (opts[2] === null || v.option3 === opts[2]);
    });
  }

  function updateSizeAvailability(sectionId, state) {
    document.querySelectorAll('[data-section-id="' + sectionId + '"][data-option-index="1"]').forEach(function(btn) {
      var sizeVal = btn.dataset.value;
      var avail = state.data.variants.some(function(v) {
        return v.available &&
               (state.selectedOptions[0] === null || v.option1 === state.selectedOptions[0]) &&
               v.option2 === sizeVal;
      });
      btn.disabled = !avail;
      btn.classList.toggle('hi-size--soldout', !avail);
    });
  }

  window.hiPdpDecQty = function(sectionId) {
    var state = pdpState[sectionId];
    if (!state || state.qty <= 1) return;
    state.qty--;
    updateQtyDisplays(sectionId, state.qty);
  };

  window.hiPdpIncQty = function(sectionId) {
    var state = pdpState[sectionId];
    if (!state) return;
    state.qty++;
    updateQtyDisplays(sectionId, state.qty);
  };

  function updateQtyDisplays(sectionId, qty) {
    ['hi-qty-display-' + sectionId, 'hi-sticky-qty-display-' + sectionId].forEach(function(id) {
      var el = document.getElementById(id);
      if (el) el.textContent = qty;
    });
    var qtyInput = document.getElementById('hi-qty-input-' + sectionId);
    if (qtyInput) qtyInput.value = qty;
  }

  window.hiToggleSizeGuide = function(sectionId) {
    var modal = document.getElementById('hi-size-guide-' + sectionId);
    if (!modal) return;
    var isOpen = modal.style.display === 'flex';
    modal.style.display = isOpen ? 'none' : 'flex';
    document.body.style.overflow = isOpen ? '' : 'hidden';
  };

  window.hiToggleAcc = function(btn) {
    var isOpen = btn.getAttribute('data-open') === 'true';
    btn.setAttribute('data-open', String(!isOpen));
    var panel = btn.nextElementSibling;
    if (panel) panel.setAttribute('data-open', String(!isOpen));
  };

  function doAddToCart(sectionId) {
    var state = pdpState[sectionId];
    if (!state) return;
    var variantId = document.getElementById('hi-variant-id-' + sectionId);
    if (!variantId || !variantId.value) return;

    var btns = [
      document.getElementById('hi-atc-btn-' + sectionId),
      document.getElementById('hi-sticky-atc-' + sectionId)
    ].filter(Boolean);

    btns.forEach(function(b) { b.disabled = true; b.textContent = window.hiI18n.adding; });

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: parseInt(variantId.value, 10), quantity: state.qty })
    })
    .then(function(r) { return r.ok ? r.json() : Promise.reject(r); })
    .then(function() {
      btns.forEach(function(b) { b.textContent = window.hiI18n.added; });
      if (typeof window.hiRefreshCart === 'function') {
        window.hiRefreshCart();
      }
      setTimeout(function() {
        btns.forEach(function(b) {
          b.disabled = false;
          b.textContent = window.hiI18n.add_to_cart;
        });
      }, 2200);
    })
    .catch(function() {
      btns.forEach(function(b) { b.disabled = false; b.textContent = window.hiI18n.add_to_cart; });
    });
  }

  window.hiAddToCart = function(sectionId) { doAddToCart(sectionId); };
  window.hiStickyAddToCart = function(sectionId) { doAddToCart(sectionId); };

  // Initialize all PDP sections
  document.querySelectorAll('[data-hi-pdp-section]').forEach(function(el) {
    initPdp(el.dataset.hiPdpSection);
  });

  // Initialize thumbnail carousel button states
  document.querySelectorAll('[id^="hi-tcarousel-"]').forEach(function(carousel) {
    var sectionId = carousel.id.replace('hi-tcarousel-', '');
    var thumbs = document.getElementById('hi-thumbs-' + sectionId);
    if (!thumbs) return;
    var total = thumbs.querySelectorAll('.hi-thumb').length;
    var btnDown = document.getElementById('hi-tcbtn-down-' + sectionId);
    if (btnDown && total <= HI_VISIBLE) btnDown.disabled = true;

    // Mobile: track scroll position to update button states
    var viewport = carousel.querySelector('.hi-thumbs-viewport');
    if (viewport) {
      viewport.addEventListener('scroll', function() {
        var btnUp = document.getElementById('hi-tcbtn-up-' + sectionId);
        var btnDn = document.getElementById('hi-tcbtn-down-' + sectionId);
        var atStart = viewport.scrollLeft <= 1;
        var atEnd = viewport.scrollLeft >= viewport.scrollWidth - viewport.clientWidth - 1;
        if (btnUp) btnUp.disabled = atStart;
        if (btnDn) btnDn.disabled = atEnd;
      });
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hi-product-related"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('hi-product-related')) {
  customElements.define('hi-product-related', class extends HTMLElement {
    connectedCallback() {
      var url = this.dataset.url;
      if (!url) return;
      fetch(url)
        .then(function(r) { return r.text(); })
        .then(function(html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var el = doc.querySelector('hi-product-related');
          if (el && el.innerHTML.trim()) {
            document.querySelector('hi-product-related[data-url="' + url + '"]').innerHTML = el.innerHTML;
          }
        });
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hi-testimonials"] && !Shopify.designMode) return;
  try {
    
(function(){
  document.querySelectorAll('[data-hi-testimonials]').forEach(function(sec){
    var track=sec.querySelector('[data-track]');
    var dots=Array.from(sec.querySelectorAll('.hi-dot'));
    if(!track||!dots.length)return;
    var count=track.children.length;
    function go(i){track.scrollTo({left:i*track.clientWidth,behavior:'smooth'});}
    function updateDots(){
      var i=Math.round(track.scrollLeft/Math.max(1,track.clientWidth));
      dots.forEach(function(d,j){
        d.setAttribute('data-active',j===i?'true':'false');
        d.setAttribute('aria-selected',j===i?'true':'false');
      });
    }
    dots.forEach(function(d,i){d.addEventListener('click',function(){go(i);});});
    track.addEventListener('scroll',updateDots,{passive:true});
    if(dots[0])dots[0].setAttribute('data-active','true');
    var auto=null;
    function stop(){if(auto){clearInterval(auto);auto=null;}}
    function tick(){var cur=Math.round(track.scrollLeft/Math.max(1,track.clientWidth));go((cur+1)%count);}
    function start(){stop();auto=setInterval(tick,5000);}
    start();
    sec.addEventListener('mouseenter',stop);
    sec.addEventListener('mouseleave',start);
    track.addEventListener('pointerdown',stop);
    window.addEventListener('pointerup',function(){if(!auto)start();});
  });
})();

  } catch(e) { console.error(e); }
})();
})();
